import { Component, Output, EventEmitter, Input, Inject } from "@angular/core";
import { combineLatest, forkJoin, Observable, of } from "rxjs";
import { mergeMap } from "rxjs/operators";

import { ButtonActions } from "../../../../app.constants";
import { StepAction } from "../../entities/step-action-entity";
import { DocumentPaButton } from "../../entities/document-pa-button";
import { DocumentPersonneAvertie } from "../../entities/document-pa.entity";
import { TraductionPaEntity } from "../../entities/traduction-pa.entity";
import { SubjectRelay } from "../../../../shared/commands/subject-relay.class";
import { GenericUpdateTraductionStepOrder } from "../../entities/document-pa-generic-update-traduction-step-order.entity";

import { DocumentPaService } from "../../services/document-pa-service";

@Component({
    selector: "consignes-pv",
    templateUrl: "consignes-pv.html",
    styleUrls: ["consignes-pv.css"],
})
export class ConsignesPvComponent {
    traductionsObligations: TraductionPaEntity[] = [];
    traductionsInterdictions: TraductionPaEntity[] = [];

    currentPaInstance!: DocumentPersonneAvertie;
    private currentPaValue?: DocumentPersonneAvertie;

    actionButtons: DocumentPaButton[] = [
        new DocumentPaButton(ButtonActions.PREVIOUS, "Back", "btn btn-primary"),
        new DocumentPaButton(ButtonActions.CANCEL, "Liste des PA", "btn btn-danger"),
        new DocumentPaButton(ButtonActions.SAVE, "Sauvegarder maintenant", "btn btn-warning"),
        new DocumentPaButton(ButtonActions.NEXT, "Next", "btn btn-success"),
    ];

    @Output() actionRequested = new EventEmitter<StepAction>();

    constructor(@Inject(DocumentPaService) private documentPaService: DocumentPaService) {
        this.currentPa$.subscribe(
            (currentPa) => {
                if (currentPa) {
                    this.currentPaInstance = new DocumentPersonneAvertie();
                    this.currentPaInstance.id = currentPa.id;
					this.currentPaInstance.etat = currentPa.etat;
                    this.currentPaInstance.categorie = currentPa.categorie;
					this.currentPaInstance.duplicatedId = currentPa.duplicatedId;
                    if (currentPa.categorie) {
                        let obligations$ = this.documentPaService.getTraductions(
                            this.currentPaInstance.categorie,
                            "CONSIGNES_RISQUE_ELEC_OBLIG_EE"
                        );
                        let interdictions$ = this.documentPaService.getTraductions(
                            this.currentPaInstance.categorie,
                            "CONSIGNES_RISQUE_ELEC_INTERD_EE"
                        );
                        let data$ = combineLatest(obligations$, interdictions$).pipe(
                            mergeMap(
                                (data) => {
                                    return forkJoin({
                                        obligations: of(data[0]),
                                        interdictions: of(data[1])
                                    });
                                }
                            )
                        );
                        data$.subscribe((data) => {
                            this.currentPaValue = currentPa;

                            this.traductionsObligations = data.obligations as TraductionPaEntity[];
                            this.traductionsInterdictions = data.interdictions as TraductionPaEntity[];
                        });
                    }
                }
            }
        );
    }

    private currentPa$ = new SubjectRelay<DocumentPersonneAvertie>();
    @Input() set currentPa(obs: Observable<DocumentPersonneAvertie> | undefined) {
        this.currentPa$.registerSource(obs);
    }

    private saveConsignesPv(afterSaveAction: ButtonActions): void {
        if (!this.currentPaInstance) {
            return;
        }

        const command = new GenericUpdateTraductionStepOrder();
        command.id = this.currentPaInstance.id;
        command.traductions = [
            ...this.traductionsObligations.map(item => this.mapTraductionToUpdateOrder(item)),
            ...this.traductionsInterdictions.map(item => this.mapTraductionToUpdateOrder(item)),
        ];

        this.documentPaService.updateConsignePvStep(command).subscribe({
            next: (response) => {
                if (this.currentPaInstance) {
                    if (this.currentPaInstance.lastCompletedStep < 4) {
                        this.currentPaInstance.lastCompletedStep = 4;
                    }
                    this.currentPaInstance.id = response.id;
                }

                this.actionRequested.emit(
                    new StepAction(this.currentPaInstance, afterSaveAction)
                );
            },
            error: (err) => {
                console.error("Erreur lors de la sauvegarde des consignes PV", err);
            },
        });
    }

    performAction(requestedAction: ButtonActions): void {
        switch (requestedAction) {

            case ButtonActions.SAVE:
                this.saveConsignesPv(ButtonActions.RETURN_TO_LIST);
                break;

            case ButtonActions.NEXT:
                this.saveConsignesPv(ButtonActions.NEXT);
                break;

            case ButtonActions.PREVIOUS:
                this.actionRequested.emit(
                    new StepAction(this.currentPaValue as DocumentPersonneAvertie, ButtonActions.PREVIOUS)
                );
                break;

            case ButtonActions.CANCEL:
            case ButtonActions.RETURN_TO_LIST:
                this.actionRequested.emit(
                    new StepAction(null, ButtonActions.RETURN_TO_LIST)
                );
                break;
        }
    }

    mapTraductionToUpdateOrder(item: TraductionPaEntity) {
        const payload: any = { traductionId: item.id };
        if (item.checked !== undefined) {
            payload.checked = item.checked;
        }
        return payload;
    }

}
